/**
 * True for a number that can safely be used as a divisor or a scale.
 *
 * Viewport maths runs against measured DOM sizes and file-derived extents, both of
 * which can be zero, `NaN`, or `Infinity`; guarding at the boundary is what keeps a
 * degenerate input from producing a non-finite transform that silently blanks the
 * canvas.
 */
export const isPositiveFinite = (value: number): boolean =>
  Number.isFinite(value) && value > 0;
